export default {
  domains: {
    created: {
      action: '$takeLast',
      moduleName: 'domains.domains',
      actionName: 'domains/domains/FETCH_ITEM',
      payloadFormatter: object => ({ id: object.id }),
      ability: {
        action: 'read',
        subject: 'domain'
      }
    },
    updated: {
      action: '$takeLast',
      moduleName: 'domains.domains',
      actionName: 'domains/domains/FETCH_ITEM',
      payloadFormatter: object => ({ id: object.id }),
      ability: {
        action: 'read',
        subject: 'domain'
      }
    },
    deleted: {
      action: 'dispatch',
      moduleName: 'domains.domains',
      actionName: 'domains/domains/ABORT_AND_REMOVE',
      payloadFormatter: object => ({ actionName: 'domains/domains/FETCH_ITEM', payload: { id: object.id } }),
    }
  },
  users: {
    created: {
      action: '$takeLast',
      moduleName: 'domains.users',
      actionName: 'domains/users/FETCH_VIEWS_BY_NOTIFICATION',
      payloadFormatter: object => ({ id: object.id, domainId: object.domain_id }),
      ability: { action: 'read', subject: 'domain_user' }
    },
    updated: {
      action: '$takeLast',
      moduleName: 'domains.users',
      actionName: 'domains/users/FETCH_VIEWS_BY_NOTIFICATION',
      payloadFormatter: object => ({ id: object.id, domainId: object.domain_id }),
      ability: {
        action: 'read',
        subject: 'domain_user'
      }
    },
    deleted: {
      action: 'dispatch',
      moduleName: 'domains.users',
      actionName: 'domains/users/ABORT_AND_REMOVE',
      payloadFormatter: object => ({ actionName: 'domains/users/FETCH_ITEM', payload: { id: object.id, domainId: object.domain_id } }),
    }
  },
  projects: {
    created: {
      action: '$takeLast',
      moduleName: 'domains.projects',
      actionName: 'domains/projects/FETCH_VIEWS_BY_NOTIFICATION',
      payloadFormatter: object => ({ id: object.id }),
      ability: { action: 'read', subject: 'domain_project' }
    },
    updated: {
      action: '$takeLast',
      moduleName: 'domains.projects',
      actionName: 'domains/projects/FETCH_VIEWS_BY_NOTIFICATION',
      payloadFormatter: object => ({ id: object.id }),
      ability: {
        action: 'read',
        subject: 'domain_project'
      },
      process: object => !!object.domain_id
    },
    deleted: {
      action: 'dispatch',
      moduleName: 'domains.projects',
      actionName: 'domains/projects/ABORT_AND_REMOVE',
      payloadFormatter: object => ({ actionName: 'domains/projects/FETCH_ITEM', payload: { id: object.id } }),
      process: object => !!object.domain_id
    }
  }
};
